import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { ORDERS_TRADES_MONITORING_LAYOUT } from './OrdersTradesMonitoring';

export const ORDERS_TRADES_MONITORING_LAYOUT_SPEC: LayoutSpec = {
  templateId: 'ordersTrades',
  label: 'Orders / Trades',
  id: 'ordersTrades',
  dockViewLayout: ORDERS_TRADES_MONITORING_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
